export enum ToasterNotificationTypeEnum {
	INFORMATION = 'information',
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning'
}